<template>
    <div>
        <PageHeader>
            <template #navbar>
                <Navbar />
            </template>
            <template #pagetitle>
                <PageTitle :pageTitle="$t('pages.titles.newsDetail')" />
            </template>
        </PageHeader>
        <SingleCasesStudyTwo />
        <FreeTrial variant="light"/>
        <Footer />
    </div>
</template>

<script>
import Navbar from '../Layout/Navbar'
import PageHeader from '../Layout/PageHeader'
import PageTitle from '../Common/PageTitle'
import SingleCasesStudyTwo from '../SingleCasesStudy/SingleCasesStudyTwo'
import FreeTrial from '../Common/FreeTrial'
import Footer from '../Layout/Footer'

export default {
    name: 'SingleCasesStudyPage',
    components: {
        Navbar,
        PageHeader,
        PageTitle,
        SingleCasesStudyTwo,
        FreeTrial,
        Footer,
    }
}
</script>
